import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const HOUSE_REFERENCE_IMAGE =
  "https://customer-assets.emergentagent.com/job_c0a9c863-2c65-4e34-8298-6a892df345990/artifacts/2d536vrt_ChatGPT%20Image%20Jul%2020%2C%202026%2C%2009_20_37%20PM.png";

// Editorial imagery — soft light, stone/travertine/linen/marble/glass palette.
export const EDITORIAL = {
  travertine: "https://images.unsplash.com/photo-1615529162924-f8605388461d?w=2200&q=90",
  linen: "https://images.unsplash.com/photo-1615873968403-89e068629265?w=2200&q=90",
  marble: "https://images.unsplash.com/photo-1526045612212-70caf35c14df?w=2200&q=90",
  glass: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=2200&q=90",
  atelier: "https://images.unsplash.com/photo-1615870216519-2f9fa575fa5c?w=2200&q=90",
  hand: "https://images.unsplash.com/photo-1602934585418-f588bea4215c?w=2200&q=90",
  water: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=2200&q=90",
  shadow: "https://images.unsplash.com/photo-1516557070061-c3d1653fa646?w=2200&q=90",
  stone: "https://images.unsplash.com/photo-1607779097040-26e80aa78e66?w=2200&q=90",
};

// House-owned reference photography (uploaded by the house).
export const KOTCHA_IMAGE = "https://customer-assets-39nsmqrw.emergentagent.net/job_korv-archive/artifacts/dti1zfvx_ChatGPT%20Image%20Aug%202%2C%202026%2C%2007_11_58%20PM.png";
export const BATH_SALT_IMAGE = "https://customer-assets-39nsmqrw.emergentagent.net/job_korv-archive/artifacts/s9o7br1a_IMG_4964.jpg";

export const REFERENCE = "https://customer-assets-lqy194kg.emergentagent.net/job_c0a9c863-2c65-4e34-8298-6a892df345990/artifacts/2d536vrt_ChatGPT%20Image%20Jul%2020%2C%202026%2C%2009_20_37%20PM.png";
